import { useState } from "react";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { Milestone } from "./milestonesTypes";
import { MilestoneCard } from "./MilestoneCard";

interface MilestonesListProps {
  milestones: Milestone[];
  onEdit: (milestone: Milestone) => void;
  onDelete: (milestone: Milestone) => void;
  onMarkComplete: (milestone: Milestone) => void;
  onReorder: (milestones: Milestone[]) => void;
}

export function MilestonesList({
  milestones,
  onEdit,
  onDelete,
  onMarkComplete,
  onReorder,
}: MilestonesListProps) {
  const [dragId, setDragId] = useState<string | null>(null);

  const handleDrop = (targetId: string) => {
    if (!dragId || dragId === targetId) return;

    const fromIndex = milestones.findIndex((item) => item.id === dragId);
    const toIndex = milestones.findIndex((item) => item.id === targetId);
    if (fromIndex < 0 || toIndex < 0) return;

    const reordered = [...milestones];
    const [moved] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, moved);
    onReorder(reordered);
    setDragId(null);
  };

  if (milestones.length === 0) {
    return (
      <Card>
        <CardContent>
          <Typography color="text.secondary">
            No milestones yet. Add your first milestone to get started.
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Stack spacing={2}>
      <Typography variant="caption" color="text.secondary">
        Drag milestones to reorder.
      </Typography>
      {milestones.map((milestone) => (
        <Box
          key={milestone.id}
          draggable
          onDragStart={() => setDragId(milestone.id)}
          onDragOver={(event) => event.preventDefault()}
          onDrop={() => handleDrop(milestone.id)}
          sx={{ cursor: "grab" }}
        >
          <MilestoneCard
            milestone={milestone}
            onEdit={onEdit}
            onDelete={onDelete}
            onMarkComplete={onMarkComplete}
          />
        </Box>
      ))}
    </Stack>
  );
}
